import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  Typography,
  Select,
  MenuItem,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import { API_URL, API_PORT } from "../../constants/appConfig";
import { useLanguage } from "../../components/languageprovider";
import language from "../../constants/language";
import { toast } from "react-toastify";

const getPackageName = (pkg, currentLanguage) => {
  const packageName = {
    tr: pkg.packageNameTr,
    de: pkg.packageNameDe,
    fr: pkg.packageNameFr,
    it: pkg.packageNameIt,
    nl: pkg.packageNameNl,
    en: pkg.packageNameEn,
  };

  return packageName[currentLanguage] || packageName.en;
};

const RegisterStepFive = ({
  userPackage,
  setUserPackage,
  isSelectedPackageMonth,
  selectedImages,
  handleSelectPriceType,
  handleImageSelection,
  setSelectedImages,
  kvkkAccepted,
  setKvkkAccepted,
}) => {
  const { currentLanguage } = useLanguage();
  const texts = language[currentLanguage];
  // packages state removed - only Gold package is used
  const [loading, setLoading] = useState(false);
  const [packageSelectSize, setPackageSelectSize] = useState(0);
  const [imageLoadingStates, setImageLoadingStates] = useState({});

  const getGoldPackage = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_URL}:${API_PORT}/package/getAllPackageWithBg?page=0&size=9999999`
      );
      const data = await response.json();
      
      // Find and set Gold package
      const goldPackage = data?.content?.find(pkg => pkg.packageId === "0GK150JZ8PDK7");
      console.log('API Response:', data);
      console.log('Gold Package:', goldPackage);
      if (goldPackage) {
        console.log('Gold Package Images:', goldPackage.packageImages);
        setPackageSelectSize(goldPackage.packageSelectSize);
        setUserPackage(goldPackage);
      } else {
        console.error('Gold package not found in API response');
      }
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getGoldPackage();
  }, []);

  // Package selection removed - Gold package is fixed

  const handleUpdateImageSelection = (imageId) => {
    // Eğer imageId, selectedImages içinde zaten varsa, fonksiyonu sonlandır
    if (selectedImages.includes(imageId)) {
      handleImageSelection(imageId);
      return; // Fonksiyonu sonlandır
    }

    // Eğer seçilebilecek paket sayısı sınırına ulaşılmışsa
    if (packageSelectSize === selectedImages.length) {
      toast.error(texts.maxImageSelection); // Hata mesajı
      return; // Fonksiyonu sonlandır
    }

    handleImageSelection(imageId);
  };
  return (
    <>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress sx={{ color: "primary.main" }} />
        </Box>
      ) : (
        <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
          {/* Gold Package Info - No Selection Needed */}
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {userPackage ? getPackageName(userPackage, currentLanguage) : "Gold Paket"}
          </Typography>
          {userPackage ? (
            <Box
              sx={{
                border: "1px solid #ddd", // Çerçeve rengi
                borderRadius: "8px", // Kenar yuvarlama
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Gölgelendirme
                p: 3, // İçerik boşluğu
                mt: 2,
              }}
            >
              <Typography variant="subtitle1">
                {texts.packageDescription}
              </Typography>

              <Typography variant="body2">
                {userPackage.packageDescription}
              </Typography>
              <Typography variant="body2" color="textDisabled">
                {userPackage.packageMontly + " "} € {" " + texts.perMonth}
              </Typography>
            </Box>
          ) : null}

          <Box
            sx={{
              border: "1px solid #ddd", // Çerçeve rengi
              borderRadius: "8px", // Kenar yuvarlama
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Gölgelendirme
              p: 3, // İçerik boşluğu
              mt: 2,
            }}
          >
            {/* Görsel Seçim Bölümü - Gold Package Images */}
            {userPackage &&
            userPackage.packageImages &&
            userPackage.packageImages.length > 0 ? (
              <>
                <Typography variant="subtitle1">
                  {texts.selectBackground} {packageSelectSize || 6}
                  {" / "} {selectedImages.length} {texts.selected}{" "}
                  {/* Arka plan seçimi başlığı */}
                </Typography>{" "}
                {/* Arka plan seçimi açıklaması */}
                <div className="image-selection flex flex-wrap gap-4 mt-4">
                  {userPackage.packageImages.map((item) => (
                    <div
                      key={item.imageId}
                      onClick={() => handleUpdateImageSelection(item.imageId)}
                      style={{
                        position: "relative",
                        cursor: "pointer",
                        border: "2px solid",
                        borderColor: selectedImages.includes(item.imageId)
                          ? "blue"
                          : "gray",
                        borderRadius: "8px",
                        overflow: "hidden",
                        width: "100px",
                        height: "100px",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={`${API_URL}:${API_PORT}/${item.imageName}`}
                        alt={item.imageName}
                        style={{
                          display: "block",
                          width: "100%",
                          height: "100%",
                          transition: "opacity 0.3s ease",
                          opacity: selectedImages.includes(item.imageId)
                            ? 0.6
                            : 1,
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          console.error('Image load error:', item.imageName);
                          setImageLoadingStates(prev => ({
                            ...prev,
                            [item.imageId]: 'error'
                          }));
                        }}
                        onLoad={() => {
                          console.log('Image loaded successfully:', item.imageName);
                          setImageLoadingStates(prev => ({
                            ...prev,
                            [item.imageId]: 'loaded'
                          }));
                        }}
                      />
                      {imageLoadingStates[item.imageId] === 'error' && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "red",
                            fontSize: "12px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            padding: "5px",
                            borderRadius: "5px",
                            textAlign: "center",
                          }}
                        >
                          Resim Yüklenemedi
                        </div>
                      )}
                      {selectedImages.includes(item.imageId) && imageLoadingStates[item.imageId] !== 'error' && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                            fontSize: "24px",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            padding: "5px 10px",
                            borderRadius: "5px",
                          }}
                        >
                          ✓
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <Typography variant="body1" color="error">
                {texts.noImagesAvailable} {/* Hata mesajı */}
              </Typography>
            )}
          </Box>
          {/* KVKK ve Kullanım Koşulları için Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                checked={kvkkAccepted}
                onChange={(e) => setKvkkAccepted(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2" sx={{ color: "gray" }}>
                {texts.kvkkConsentMessage}{" "}
                <a
                  href="/kvkk.html"
                  target="_blank"
                  style={{ color: "gray", textDecoration: "underline" }}
                >
                  {texts.kvkkLinkText}
                </a>
              </Typography>
            }
          />
        </Box>
      )}
    </>
  );
};

export default RegisterStepFive;
